/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createRefreshProductFamilySummariesResponseFromDiscriminatorValue, type ErrorResponse, type InternalErrorResponse, type RefreshProductFamilySummariesResponse } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/product-families/refresh-summaries
 */
export interface RefreshSummariesRequestBuilder extends BaseRequestBuilder<RefreshSummariesRequestBuilder> {
    /**
     * Recomputes each family's card summary (price range per tier, variant counts, available option values, lead image) from its variants. Run after a bulk price import; day-to-day writes keep summaries current on their own.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<RefreshProductFamilySummariesResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<RefreshProductFamilySummariesResponse | undefined>;
    /**
     * Recomputes each family's card summary (price range per tier, variant counts, available option values, lead image) from its variants. Run after a bulk price import; day-to-day writes keep summaries current on their own.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const RefreshSummariesRequestBuilderUriTemplate = "{+baseurl}/api/product-families/refresh-summaries";
/**
 * Metadata for all the requests in the request builder.
 */
export const RefreshSummariesRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: RefreshSummariesRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createRefreshProductFamilySummariesResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
